import {
  GET_DEPARTMENT_LOOKUP_OK,
  GET_DEPARTMENT_LOOKUP_ERR,
} from "./department.action";

const InitState = {
  error: null,
  content: null,
};

export default function DepartmentLookupAdmReducer(state = InitState, action) {
  switch (action.type) {
    case GET_DEPARTMENT_LOOKUP_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_DEPARTMENT_LOOKUP_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
